import JsonField from './JsonField.js'
import formats from '../../../api/formats'
import dialogs from '../../common/dialogs.js'
import forms from '../../common/forms.js'
import people from '../../people'

export default
class IndividualField extends JsonField {
  getDescription (model) {
    let obj = model[this.name] ? JSON.parse(model[this.name]) : null
    if (!obj) {
      return ''
    }
    return `${obj.lastName} ${obj.firstName} ${obj.middleName} ИНН: ${formats.formatInnfl(obj.innfl)}`
  }
  open (model, onChange) {
    let key = this.getCode(model)
    let fstrategy = this.getStrategy()
    if (!fstrategy) {
      return
    }
    forms.openFormStg(fstrategy, key).then((key) => {
      this.setCode(model, key, onChange)
    })
    return
  }
  select (model, onChange) {
    const companyRefCode = this.cxt.getReferenceCompanyRefCode(model, this.name)
    console.log('select', companyRefCode)
    const setPerson = (id) => {
      this.setCode(model, id, onChange)
    }
    const getQueryCxt = () => {
      let refCode = companyRefCode
      if (formats.isRefCode(refCode)) {
        return refCode
      } else {
        dialogs.message(this, 'Совет', 'Сначала выберите компанию')
      }
    }
    Promise.resolve()
    .then(() => {
      if (this.getCode(model)) {
        people.getIndividual(this.getCode(model))
      } else {
        return null
      }
    })
    .then((individual) => {
      let queryString = individual ? (individual.innfl ? individual.innfl : individual.lastName) : null
      const getQuery = () => queryString
      if (!['LOCAL'].includes(this.ref)) {
        let queryCxt = getQueryCxt()
        if (formats.isRefCode(queryCxt)) {
          people.selectIndividual(this.cxt.context, queryCxt, getQuery, true, true)
            .then((values) => {
              if (Array.isArray(values) && values.length > 0) {
                setPerson(values[0])
              }
            })
        }
      }
      if (['LOCAL'].includes(this.ref)) {
        people.selectIndividual(this.cxt.context, null, getQuery, true, true)
        .then((values) => {
          if (Array.isArray(values) && values.length > 0) {
            setPerson(values[0])
          }
        })
      }
    })
  }
  fillRef (model, data, onChange) {
    let individual = data
    var refs = this.cxt.refMap.get(this.name)
    if (refs) {
      refs.forEach(r => {
        let fobj = this.cxt.fieldObjects.get(r)
        let obj, code
        if (fobj.type === 'CONTACT') {
          let items = individual ? individual.contacts : []
          items = people.sortIndividualContact(items)
          obj = items.length > 0 ? items[0] : null
          code = obj ? obj.id : null
        }
        if (people.registeredTypeDoc().includes(fobj.type)) {
          let docs = individual && individual.docs ? individual.docs.filter(d => d.type === fobj.type) : null
          console.log('fillRef', docs)
          docs = docs ? people.sortIndividualDoc(docs) : docs
          obj = docs && docs.length > 0 ? JSON.parse(docs[0].model) : null
          code = docs && docs.length > 0 ? docs[0].id : null
        }
        fobj.setValue(
          model,
          code,
          obj,
          onChange
        )
        // console.log('fillRefPersonValues', code)
      })
    }
    this.cxt.updateItems(model)
  }
}



// WEBPACK FOOTER //
// ./src/components/assist/fields/IndividualField.js